import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchMatchData } from '../../actions/matchDataActions';
import ListMatch from '../../components/content/matches/ListMatch';
import { switchPage } from '../../actions/pageAction';
import './Home.css';
import { PullHook } from 'react-onsenui';
import Layouts from '../../components/layouts/Layouts';
import { Tabs, ActivityIndicator as Refreshing } from 'antd-mobile';
import PropTypes from 'prop-types';
import Toolbar from '../../components/headers/home/Toolbar';
import NoResult from '../../components/content/result/NoResult';
import AccessDenied from '../../components/content/result/AccessDenied';
import { initializeConnexion } from '../../actions/connexionActions';

const Home = props => {
    const access = props.connexionReducer;
    const [isRefresh, setIsRefresh] = useState(true);
    const [onInit, setOnInit] = useState(true);

    useEffect(() => {
        if(access) {
            setIsRefresh(true);
            props.fetchMatchData(access).finally(() => {
                setIsRefresh(false);
                setOnInit(false);
            });
        }
    }, [access])

    const settings = [
        {
            key: 'edit',
            to: '/profile/settings',
            name: 'Modifier le profil'
        },
        {
            key: 'demo',
            to: '/live/demo',
            name: 'Démo'
        }
    ];

    const {upcoming, past} = props.matchDataReducer;

    window.postMessage(JSON.stringify({action: 'setBatchAttribute', parameters: {
        upcoming_match: !_.isEmpty(upcoming),
        past_match: !_.isEmpty(past)
    }}), '*');

    return(
        <Layouts
            toolbar={() => <Toolbar close settings={settings} title='Live score' />}
        >
            <Tabs tabs={[
                {title: <span style={{fontSize: '13px'}}>Matchs à venir</span>},
                {title: <span style={{fontSize: '13px'}}>Matchs passés</span>}
            ]}
                initialPage={props.pageReducer === 'upcomingMatch' ? 0 : 1}
                tabBarBackgroundColor={'#004586'}
                tabBarActiveTextColor={'#fff'}
                tabBarInactiveTextColor={'#fff'}
                tabBarTextStyle={{textTransform: 'uppercase'}}
                tabBarUnderlineStyle={{height: '5px', backgroundColor: '#82d0f4'}}
                onChange={(models, index) => {
                    props.switchPage(index === 0 ? 'upcomingMatch' : 'pastMatch');
                    if((_.isEmpty(upcoming) && index === 0) || (_.isEmpty(past) && index === 1)) {
                        setIsRefresh(true);
                    }
                    props.fetchMatchData(access).finally(() => {
                        setIsRefresh(false);
                        setOnInit(false);
                    });
                }}
                swipeable={false}
            >
                {
                    (upcoming && !_.isEmpty(upcoming) && !onInit && access !== -1) &&
                    <ListView 
                        id='ls_pull_to_refresh_upcoming' 
                        list={upcoming} 
                        page={'upcomingMatch'} 
                        setIsRefresh={setIsRefresh} 
                        access={access} 
                        fetchMatchData={props.fetchMatchData} 
                    />
                }
                {
                    (past && !_.isEmpty(past) && !onInit && access !== -1) &&
                    <ListView 
                        id='ls_pull_to_refresh_past'
                        list={past}
                        page='pastMatch'
                        setIsRefresh={setIsRefresh} 
                        access={access} 
                        fetchMatchData={props.fetchMatchData}
                    />
                }
            </Tabs>
            {
                isRefresh && 
                <div style={{position: 'absolute', right: 0, left: 0, top: '20%', justifyContent: 'center', display: 'flex'}}>
                    <Refreshing animating size='large' />
                </div>
            }
            {displayResult(props, access, onInit)}
        </Layouts>
    )
}

const mapStateToProps = ({matchDataReducer, connexionReducer, pageReducer}) => ({matchDataReducer, connexionReducer, pageReducer});

const mapDispatchToProps = dispatch => bindActionCreators({fetchMatchData,switchPage, initializeConnexion}, dispatch);

const displayResult = (props, access, onInit) => {
    const {upcoming, past} = props.matchDataReducer;
    if(!onInit) {
        if(access === -1) {
            return <AccessDenied />
        }
        else if(_.isEmpty(upcoming) && _.isEmpty(past) && !onInit) {
            return <NoResult />
        }
    }
}

const ListView = props => {
    const list = _.reject(props.list, (l,k) => k === 'cache_ttl_expires_at');
    return (
        <div 
            id={props.id} 
            className='ls_pull_to_refresh'>
            <PullHook
                thresholdHeight={200}
                height={15}
                onChange={e => {
                    const element = document.getElementById(props.id);
                    if(e.state === 'action' && parseFloat(element.getBoundingClientRect().top) > 102.5) {
                        props.setIsRefresh(true);
                        localStorage.removeItem('matchData');
                        props.fetchMatchData(props.access).then(() => props.setIsRefresh(false));
                    }
                    else {
                        props.setIsRefresh(false)
                    }
                }}
                onLoad={() => {
                    const element = document.getElementById(props.id);
                    element.classList.remove('ls_pull_to_refresh');
                }}
                style={{display: 'block'}}
            >
                <ListMatch list={list} page={props.page} />
            </PullHook>
        </div>
    );
}

ListView.propTypes = {
    id: PropTypes.string.isRequired,
    access: PropTypes.string.isRequired,
    fetchMatchData: PropTypes.func.isRequired,
    setIsRefresh: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
    list: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
}

Home.propTypes = {
    fetchMatchData: PropTypes.func.isRequired,
    matchDataReducer: PropTypes.object.isRequired,
    switchPage: PropTypes.func.isRequired,
    initializeConnexion: PropTypes.func.isRequired,
    connexionReducer: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);